import styled from "@emotion/styled";
import { Button } from "@the-game/components";
import { breakpoint, calcRem } from "@the-game/components/utils";
export const StyledHeader = styled("header")(({ theme }) => ({
  height: calcRem(80),
  display: "grid",
  gridTemplateColumns: "140px 1fr 140px",
  paddingLeft: theme.spacing.xs,
  paddingRight: theme.spacing.xs,
  gap: theme.spacing.xxs,
  position: "relative",
  [breakpoint("xs")]: {
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
    gap: theme.spacing.xs
  },
  [breakpoint("md")]: {
    gridTemplateColumns: "140px 1fr 140px"
  },
  [breakpoint("md")]: {
    boxShadow: "0px 1px 0px #CECECE",
    zIndex: 2
  },
  [breakpoint("lg")]: {
    height: calcRem(88),
    gridTemplateColumns: `200px auto auto`
  }
}));
export const LogoContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gridColumn: "1 / 2",
  [breakpoint("md")]: {
    justifyContent: "center",
    gridColumn: "2 / 3"
  },
  [breakpoint("lg")]: {
    justifyContent: "flex-start",
    gridColumn: "1 / 2"
  }
});
export const ButtonContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gridColumn: "-2 / -1"
});
export const StyledLoginButton = styled(Button)({
  height: calcRem(48)
});
export const StyledDualLogoContainer = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "50px 1px 77px",
  gridTemplateRows: "1fr",
  gridColumnGap: theme.spacing.sm,
  fontSize: calcRem(10),
  color: theme.colors.palette.neutral70,
  alignItems: "center",
  justifyContent: "center",
  "> *:first-child": {
    gridRow: "1 / -1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 50
  },
  "> *:last-child": {
    fill: theme.colors.palette.tab,
    alignSelf: "flex-start",
    width: 77,
    textAlign: "left"
  },
  img: {
    paddingTop: 8,
    width: 50,
    marginLeft: 8
  }
}));
export const Line = styled("div")(({ theme }) => ({
  display: "flex",
  alignSelf: "center",
  height: 40,
  backgroundColor: theme.colors.palette.neutral50,
  width: "100%",
  gridRow: "1 / -1"
}));
